import { ExtendedKeyMapOptions } from 'react-hotkeys';

// TODO: add support for 'sequences' as well.
// Returns human readable text from a key sequence.  For now just return the string.
export function getHotKeyText(hotKeyOptions: ExtendedKeyMapOptions): string {
  return hotKeyOptions.sequence as string;
}
